import { fetch } from '@/plugins/axios.js'
import site from '@/utils/site'
import { getInitLang } from '@/utils/lang';
const apiUrl = {
  lang: `/home/language`, // 语言
  language: `/language/index`, // 语言包
  publicNav: `/home/nav`, // 头部/底部导航
  rightFlex: `/home/sidebar`, // 右侧固定栏
  banner: `/home/banner`, // banner
  navigator: `/home/navigation`, // 面包屑
  follow: `/home/follow`, // 社交媒体
  newLang: `/language/info/lan`, // 语言 新接口
};

// 语言
export const getLang = async () => {
  const lang = await getInitLang();
  return fetch(`${apiUrl.lang}/${lang}/${site}`);
};

// 路由跳转校验数据
export const getNewLang = () => {
  const arr = window.location.pathname.split('/');
  return fetch(`${apiUrl.newLang}/${arr[2]}/${site}`);
};

// 语言包
export const getLanguage = async () => {
  const lang = await getInitLang();
  return fetch(`${apiUrl.language}/${lang}/${site}`);
};

// 头部/底部导航
export const getPublicNav = async (params) => {
  const lang = await getInitLang();
  return fetch(`${apiUrl.publicNav}/${lang}/${site}`, params);
};

// 右侧固定栏
export const getRightFlex = async () => {
  const lang = await getInitLang();
  return fetch(`${apiUrl.rightFlex}/${lang}/${site}`);
};

// banner
export const getBanner = async (params) => {
  const lang = await getInitLang();
  return fetch(`${apiUrl.banner}/${lang}/${site}` + `?menu_id=${params.menu_id}&banner_id=${params.banner_id}`);
};

// 面包屑
export const getNavigator = async (params) => {
  const lang = await getInitLang();
  return fetch(`${apiUrl.navigator}/${lang}/${site}` + `?type=${params.type}&id=${params.id}&level=${params.level}`);
};

// 社交媒体
export const getFollow = async () => {
  const lang = await getInitLang();
  return fetch(`${apiUrl.follow}/${lang}/${site}`);
};
